import React, { useEffect, useState } from 'react';
import { APPS, PERMISSIONS } from 'components/constants';
import { FormBuilder, ValidateForm, ModalAlert, ModalForm } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { line_items_form_layout } from 'components/line-items/line-item-form/line-item-form-layout';
import { confirmDelete } from 'components/common/toolbox';

const _ = require('lodash');

const LineForm = (props) => {
	
	/* Hooks --------------------------*/
	
	const history = useHistory();

	const admin = useSelector((store) => store.admin);
	const user = useSelector(store => store.users?.user);
	const user_permissions = useSelector(store => store.users?.user_permissions);
	const work_order = useSelector((store) => store.workOrders.work_order);

	const [focusedInput, setFocused] = useState(null);
	const [formError, setFormError] = useState(null);
	const [original, setOriginal] = useState({});
	const [lineItem, setLineItem] = useState();

    const isAssigned = (work_order?.technicianId == user?.profileId);
    const isOwned = (work_order?.ownerId == user?.email);
    const canEdit = user_permissions[PERMISSIONS.WORK_ORDERS_EDIT.key] || isOwned || (isAssigned && user_permissions[PERMISSIONS.WORK_ORDERS_ASSIGNED_EDIT.key]);
    const canDelete = user_permissions[PERMISSIONS.WORK_ORDERS_DELETE.key] || isOwned;

	useEffect(() => {
		setLineItem(props.lineItem);
		setOriginal(props.lineItem);
	}, []);

	/* Handlers --------------------------*/

	const handleChange = (event, value) => {
        let newValue = (value || value == 0) ? value.toString() : event.target.value;
		let form_error = _.filter(formError, (o) => { return o.field !== event.target.name; });
		setFormError(form_error);
		setLineItem(prev => ({ ...prev, [event.target.name]: newValue }));
	};
	const handleCheckbox = (field) => {
		setLineItem(prev => ({ ...prev, [field]: !prev[field] }));
	};
	
	/* Actions --------------------------*/
	
	const submitForm = () => {
		var form_error = ValidateForm(lineItem, form_layout);
		setFormError(form_error);

		let update = { ...lineItem, calculatedPrice: lineItem.price * lineItem.count }
		
		if (!form_error?.length) {
			props.handleUpdate(original, update);
			history.goBack();
		};
	};

	const form_layout = line_items_form_layout(lineItem, props.taxRate);

	return (
		<ModalForm {...props}
			style={1}
			size={'lg'}
			history={history}
			modal_header={`Edit Line Item`}
			cancel_button_title="Cancel"
			save_button_title={'Save Changes'}
			submitFormHandler={submitForm	}
			confirm_button_disabled={ !canEdit }
			delete_button_title={'Delete'}
			delete_button_callback={ () => {
				confirmDelete('Line Item', props.removeItem.bind(this, lineItem), { soft: true });
				history.goBack();
			}}
			delete_button_disabled={ !canDelete }
			focusedInput={(window.flutter) ? focusedInput : null}
			platform={admin.flutter_platform}
			keyboardPadding={admin.flutter_keyboard}
		>
			{lineItem &&
				<FormBuilder
					callbacks={{
						focus: (event) => setFocused(event.target),
						text: handleChange,
						select: handleChange,
						checkbox: handleCheckbox,
					}}
					form_error={formError}
					form={form_layout}
					record={lineItem}
				/>
			}
		</ModalForm>
	);
};

export default LineForm;